import styled from "styled-components";
import { spacing } from "src/design-system/tokens/spacing";
import { border_radius } from "src/design-system/tokens/border";
import color from "src/design-system/tokens/color";
import { textColorBasedOnBackgroundColor } from "../../utils/color";
import type { Mode } from "../../utils/types/mode";
import { fontWeight, textColor, fontSize } from "../../theme";

export type LineNameProps = {
  name: string;
  transitMode: Mode;
  textColor?: string;
  backgroundColor?: string;
  className?: string;
  labelledby?: string;
  spacing?: string;
  title?: string;
};

export function LineName(props: LineNameProps) {
  const backgroundColor = props.backgroundColor
    ? `#${props.backgroundColor}`
    : color.transport[props.transitMode];

  let calculatedTextColor;
  if (props.backgroundColor && props.textColor) {
    calculatedTextColor = `#${props.textColor}`;
  } else if (props.backgroundColor) {
    calculatedTextColor =
      textColorBasedOnBackgroundColor(props.backgroundColor) === "light"
        ? textColor.primaryOnDark
        : textColor.primaryOnLight;
  } else {
    // If we're falling back to our default transit colors, make the text white
    calculatedTextColor = textColor.primaryOnDark;
  }

  return (
    <Wrapper
      aria-labelledby={props.labelledby}
      $textColor={calculatedTextColor}
      $backgroundColor={backgroundColor}
      className={props.className}
      title={props.title ?? props.name}
      $spacing={props.spacing}
    >
      {props.name}
    </Wrapper>
  );
}

type WrapperProps = {
  $textColor: string;
  $backgroundColor: string;
  $spacing?: string;
};

const Wrapper = styled.span<WrapperProps>`
  display: inline-block;
  background-color: ${(props) => props.$backgroundColor};
  color: ${(props) => props.$textColor};
  margin: 0 ${(props) => props.$spacing} 0 0;
  padding: ${spacing.sm} ${spacing.md};
  border-radius: ${border_radius.rounded_sm};
  font-size: ${fontSize.small};
  font-weight: ${fontWeight.medium};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
